import {
  GetLoginFeaturesResponse,
  LoginFeatures,
} from '@weave/schema-gen-ts/dist/schemas/login-features/v1/service.pb';
import { AuthStorage, localStorageHelper } from '@frontend/auth-helpers';
import { baseFetch } from './fetch-wrapper';

export const getLoginFeatures = async (): Promise<string[]> => {
  const fingerprint = localStorageHelper.get(AuthStorage.sign_in_fingerprint);
  const response = await LoginFeatures.GetLoginFeatures(baseFetch<GetLoginFeaturesResponse>(), { fingerprint });
  return response.features || [];
};
